import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Project } from 'src/app/core/objects/project';
import { ProjectService } from 'src/app/core/services/project.service';
import { WorkSpace } from 'src/app/core/types';

@Component({
    selector: 'gl-overlaps-loading-spaces',
    templateUrl: './overlaps-loading-spaces.component.html',
    styleUrls: ['./overlaps-loading-spaces.component.scss'],
    standalone: false
})
export class OverlapsLoadingSpacesComponent implements AfterViewInit, OnDestroy {
  @Input() public isMobile: boolean;
  @HostBinding('class.isMobile') public mobileClass: boolean;
  public workSpaces: WorkSpace[] = [];
  @HostBinding('class.showPagination') public showPagination: boolean;
  @ViewChild('workSpacesEl', { static: false }) public workSpacesElRef: ElementRef<HTMLDivElement>;
  public isClosed = false;
  private currentWorkSpaceIndex: number;
  private project: Project;
  private subscribtions: Subscription[] = [];

  constructor(private projectService: ProjectService, private router: Router) {
    this.mobileClass = this.router.url.includes('mobile');
    this.subscribtions.push(
      this.projectService.project.subscribe((project) => {
        this.project = project;
        this.workSpaces = project.workSpaces;
        setTimeout(() => {
          this.setShowPagination();
        });
      }),
    );
    this.subscribtions.push(
      this.projectService.currentWorkSpaceIndex.subscribe((currentWorkSpaceIndex: number) => {
        this.currentWorkSpaceIndex = currentWorkSpaceIndex;
        setTimeout(() => this.scrollToOpenLoadingSpace());
      }),
    );
  }

  public ngAfterViewInit() {
    this.workSpacesElRef.nativeElement.addEventListener(
      'wheel',
      (event) => this.scrollListener(event),
      true,
    );
  }

  public collapse(): void {
    this.isClosed = !this.isClosed;
  }

  public ngOnDestroy() {
    this.workSpacesElRef.nativeElement.removeEventListener(
      'wheel',
      (event) => this.scrollListener(event),
      true,
    );
    this.subscribtions.forEach((s) => s.unsubscribe());
  }

  public checkIsCurrentWorkSpace(index: number) {
    if (typeof index === 'number') {
      return this.currentWorkSpaceIndex === index;
    }
  }

  public changeCurrentWorkSpace(index: number) {
    if (typeof index === 'number') {
      this.projectService.setState(this.project, index);
      this.projectService.openClosedLoadingSpace(index);
    }
  }

  public isCargoSpaceDefined(length: number) {
    return this.workSpaces.length > length;
  }

  public scrollListener(e: WheelEvent) {
    if (e.type !== 'wheel') {
      return;
    }
    const delta = ((e.deltaY || e.detail)) >> 10 || 1;
    this.workSpacesElRef.nativeElement.scrollLeft += delta * 40;
    e.preventDefault();
  }

  public scrollToOpenLoadingSpace() {
    const workSpacesWidth: number = this.workSpacesElRef.nativeElement.offsetWidth;
    const workSpacesScrollLeft: number = this.workSpacesElRef.nativeElement.scrollLeft;
    const offsetLeftCurrentLoadingSpace: number = (this.workSpacesElRef.nativeElement.children[this.currentWorkSpaceIndex] as HTMLDivElement)?.offsetLeft;
    const OPEN_LOADING_SPACE_WIDTH = 25;
    const locationCurrentLoadingSpace: number =
      offsetLeftCurrentLoadingSpace + OPEN_LOADING_SPACE_WIDTH - workSpacesScrollLeft;
    if (locationCurrentLoadingSpace > workSpacesWidth) {
      this.scrollByLength(
        offsetLeftCurrentLoadingSpace +
          OPEN_LOADING_SPACE_WIDTH -
          workSpacesScrollLeft -
          workSpacesWidth,
      );
    } else if (locationCurrentLoadingSpace < OPEN_LOADING_SPACE_WIDTH) {
      this.scrollByLength(offsetLeftCurrentLoadingSpace - workSpacesScrollLeft);
    }
  }

  private scrollByLength(scrollLength: number) {
    this.workSpacesElRef.nativeElement.scrollBy({
      left: scrollLength,
      behavior: 'smooth',
    });
  }

  private setShowPagination() {
    if (this.workSpaces.length > 1) {
      this.showPagination = true;
    } else {
      this.showPagination = false;
    }
  }
}
